import { createReducer, on } from '@ngrx/store';
import {
  deleteViewerInfo,
  dragDropFailure,
  dragDropSuccess,
  parTblFailure,
  parTblSuccess,
  setRuntimeWorkflowStatusField,
  tableTypeFailure,
  tableTypeSuccess,
  updParentTbl,
  updTableType,
  updateAppDM,
  updateAppDMFailure,
  updateAppDMSuccess,
  updateDragDrop,
  updateViewerInfo
} from '../actions/applicationdatamodel.actions';

export interface AppDataModelState {
  data: any;
}

export const initialState: AppDataModelState = {
  data: {}
};

export const appDatamodelReducer = createReducer(
  initialState,
  on(updateAppDM, (state, { apiConstants, appDMData }) => {
    return {
      ...state,
      ...apiConstants,
      ...appDMData
    };
  }),
  on(updateAppDMSuccess, (state, { appDMSuccData }) => {
    return {
      ...state,
      ...{ appDMSuccData }
    };
  }),
  on(updateAppDMFailure, (state, { appDMFailData }) => {
    return {
      ...state,
      ...{ appDMFailData }
    };
  }),
  on(updateViewerInfo, (state, { vwApiConstants, userData }) => {
    return {
      ...state,
      ...vwApiConstants,
      ...userData
    };
  }),
  on(deleteViewerInfo, (state, { delApiConstants, userData }) => {
    return {
      ...state,
      ...delApiConstants,
      ...userData
    };
  }),
  on(updateDragDrop, (state, { dropApiConstants, data }) => {
    return {
      ...state,
      ...dropApiConstants,
      ...data
    };
  }),
  on(dragDropFailure, (state, { dropFailed }) => {
    return {
      ...state,
      ...{ dropFailed }
    };
  }),
  on(dragDropSuccess, (state, { dropSucc }) => {
    return {
      ...state,
      ...{ dropSucc }
    };
  }),
  on(updParentTbl, (state, { parApiConstants, parTblData }) => {
    return {
      ...state,
      ...parApiConstants,
      ...parTblData
    };
  }),
  on(parTblFailure, (state, { parTblFailed }) => {
    return {
      ...state,
      ...{ parTblFailed }
    };
  }),
  on(parTblSuccess, (state, { parTblSucc }) => {
    return {
      ...state,
      ...{ parTblSucc }
    };
  }),
  on(updTableType, (state, { tblTypeApiConstants, payload }) => {
    return {
      ...state,
      ...tblTypeApiConstants,
      ...payload
    };
  }),
  on(tableTypeFailure, (state, { tblTypeFailed }) => {
    return {
      ...state,
      ...{ tblTypeFailed }
    };
  }),
  on(tableTypeSuccess, (state, { tblTypeSucc }) => {
    return {
      ...state,
      ...{ tblTypeSucc }
    };
  }),
  on(setRuntimeWorkflowStatusField, (state, { runtimeWorkflowStatusField }) => {
    return {
      ...state,
      ...{ runtimeWorkflowStatusField: runtimeWorkflowStatusField }
    };
  })
);
